// ContactSection.js
import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

function ContactSection() {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.3 });
  const isMobile = window.innerWidth <= 768;

  return (
    <section
      ref={ref}
      style={{
        height: '100vh',
        scrollSnapAlign: 'start',
        padding: isMobile ? '40px 5vw' : '60px 20px',
        backgroundColor: '#e3f2fd',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        style={{ fontSize: isMobile ? '6vw' : '2rem', marginBottom: '20px' }}
      >
        지금 시작해보세요
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ delay: 0.3, duration: 0.6 }}
        style={{
          fontSize: isMobile ? '4vw' : '1.1rem',
          marginBottom: '30px',
          color: '#555',
          maxWidth: '600px',
          lineHeight: '1.6',
          whiteSpace: 'pre-line'
        }}
      >
        집중력 훈련이 필요한 아이가 있다면,
지금 EYAS-Focus를 무료로 체험해보세요.
      </motion.p>
      <motion.a
        href="/Login"
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ delay: 0.5, duration: 0.6 }}
      >
        <button style={{
          padding: isMobile ? '3vw 6vw' : '12px 28px',
          fontSize: isMobile ? '1rem' : '16px',
          backgroundColor: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer'
        }}>
          체험판 신청하기
        </button>
      </motion.a>
    </section>
  );
}

export default ContactSection;